import ottLogo from "@/../public/img/racing-victoria/rv-ott-ar.png";
import { TrackedBox } from "@/components/shared/TrackedBox";
import { Box } from "@mui/material";
import Image from "next/image";

export function AdOttLogo({
  alwaysSmall,
  isSearchResult,
  isOnGrey,
}: {
  alwaysSmall?: boolean;
  isSearchResult?: boolean;
  isOnGrey?: boolean;
}) {
  const smallStyling = {
    padding: 0.5,
    paddingLeft: alwaysSmall ? (isSearchResult ? 2 : 0) : 1,
    paddingRight: isSearchResult ? 2 : 1,
    marginTop: -1,
    img: {
      height: 30,
      width: "auto",
    },
  };
  return (
    <Box
      sx={(theme) => ({
        borderRadius: "0 32px 32px 0",
        backgroundColor: isOnGrey ? "grey.100" : "white",
        padding: 1,
        paddingLeft: 4,
        paddingRight: 4,
        [theme.breakpoints.down("sm")]: smallStyling,
        ...(alwaysSmall ? smallStyling : {}),
      })}
    >
      <TrackedBox>
        <Image
          src={ottLogo}
          alt="Racing Victoria Off The Track"
          width={130}
          height={50}
        />
      </TrackedBox>
    </Box>
  );
}
